import FireDepartmentModelBase from '../_generated/modelBases/fire-department-model-base';

export default class FireDepartmentModel extends FireDepartmentModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
